<template>
  <div>
    <div class="">
      <CommandVue v-if="view == 'home'"  @setView="setView"/>
    </div>
    <FooterVue v-if="view == 'home'" :view="view" @setView="setView" />
  </div>
</template>

<script>
import CommandVue from "../../components/Cocina/demo/Command.vue";
import FooterVue from "../../components/Cocina/demo/Footer.vue";

export default {
  components: { FooterVue,CommandVue },
  data() {
    return {
      view: "home",
    };
  },
  methods: {
      setView: function (payload) {
        // this.view = payload;
        this.$store.commit("mt_set_rol", null);
      },
      mtdViewFooter: function (boo, view) {
        this.booFooter = boo;
        if (boo == true) this.view = view;
      },
  },
};
</script>

<style lang="scss" scoped>
</style>